// Services
import { Get, Post } from "../../services/ApiRequest";

import { ACCOUNTS_ENDPOINT, REPORT_ENDPOINT, WIDGETS_ENDPOINT } from "./config";
import { buildApiParams, toAccountId } from "./filters";
import {
  emptyReport,
  normalizeAccounts,
  normalizeReport,
  normalizeWidgets,
} from "./report";

export const getReport = (filters, perPage) => {
  if (!toAccountId(filters.accountId)) {
    return Promise.resolve(emptyReport());
  }

  return Post(REPORT_ENDPOINT, buildApiParams(filters)).then((response) =>
    normalizeReport(response, filters.page, perPage)
  );
};

export const getAccounts = () => Get(ACCOUNTS_ENDPOINT).then(normalizeAccounts);

export const getWidgets = (accountId) => {
  const id = toAccountId(accountId);

  if (!id) {
    return Promise.resolve([]);
  }

  return Post(WIDGETS_ENDPOINT, { account_id: id }).then((response) =>
    normalizeWidgets(response, accountId)
  );
};

export const getFilterOptions = (accountId) =>
  Promise.all([getAccounts(), getWidgets(accountId)]).then(
    ([accounts, widgets]) => ({ accounts, widgets })
  );
